<lib-ngx-image-zoom
  *ngIf="isImage && zoomMode"
  [thumbImage]="content"
  [fullImage]="content"
  zoommode="hover"
  enableScrollZoom="true"
  enableLens="true"
  maxZoomRatio="4"
  lensWidth="300"
  lensHeight="200"
></lib-ngx-image-zoom>

<div *ngIf="isImage && !zoomMode">
  <img [src]="content" alt="image-content"/>
</div>

<div *ngIf="isText">
  <div>{{ content }}</div>
</div>

<div *ngIf="isPdf">
  <ngx-extended-pdf-viewer
    [src]="content"
    [useBrowserLocale]="true"
    [textLayer]="true"
    [showHandToolButton]="true"
    [showToolbar]="true"
    [filenameForDownload]="fileName"
    [showDrawEditor]="false"
  >
  </ngx-extended-pdf-viewer>
</div>

<div *ngIf="isUnknown" fxLayout="column" fxLayoutAlign="center center">
  <h4>{{ "claims-center.claimDocumentation.noContentPreview" | translate }}</h4>

  <button kendoButton look="outline" icon="download" (click)="downloadFile()">
    {{ "claims-center.claimDocumentation.downloadFile" | translate }}
  </button>
</div>
